<script>
import auth from '../auth';
import UserChangePasswordOwn from './UserChangePasswordOwn.vue';
import UserChangePasswordOther from './UserChangePasswordOther.vue';

export default {
  name: 'UserChangePassword',

  props: {
    userId: {
      type: Number,
      required: true,
    },
  },

  render(createElement) {
    const actorId = auth.getViewer().id;
    const componentType = getComponentType(actorId, this.userId);
    const data = {
      props: {
        userId: this.userId,
      },
    };
    return createElement(componentType, data);
  },
};

function getComponentType(actorId, userId) {
  if(actorId === userId) {
    return UserChangePasswordOwn;
  }
  return UserChangePasswordOther;
}
</script>
